<div #formElement role="group" [formGroup]="form" class="container" [class.hide-date]="!!hideDate" [class.hide-time]="!!hideTime">
	<div class="date" [style.width]="widths[0]" *ngIf="!hideDate">
		<input
			#dateMask
			class="mat-input-element"
			[value]="form?.get('date')?.value | date: dateFormat"
			(focus)="showAndFocus(dateInput, dateMask)"
		>
		<input
			#dateInput
			matInput
			class="mat-input-element"
			style="display: none"
			formControlName="date"
			[matDatepicker]="picker"
			(blur)="blur(dateMask, dateInput)"
			(keydown)="dateKeyDown($event, dateInput)"
		>
		<mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
		<mat-datepicker #picker></mat-datepicker>
	</div>
	<div class="time" [style.width]="widths[1]" *ngIf="!hideTime">
		<input
			#timeInput
			matInput
			class="mat-input-element"
			autocomplete="off"
			[value]="form.get('time').value | date: timeFormat"
			(change)="timeChange($event.target.value)"
		>
		<ng-container *ngIf="hideDate">
			<mat-icon class="time-icon" (click)="setDateTime(false, 'now')" [matTooltip]="'Current Time (' + (app.now | async | date: timeFormat) + ')'">schedule</mat-icon>
		</ng-container>
		<ng-container *ngIf="!hideDate">
			<mat-icon class="time-icon" [matMenuTriggerFor]="allMenu">expand_more</mat-icon>
		</ng-container>
	</div>
</div>

<mat-menu #allMenu="matMenu">
	<button mat-menu-item *ngIf="!hideTime" (click)="setDateTime(false, 'now')">Current Time ({{ app.now | async | date: timeFormat }})</button>
	<button mat-menu-item *ngIf="!hideDate && !hideTime" (click)="setDateTime(true, 'now')">Now ({{ app.now | async | date: bothFormat }})</button>
	<button mat-menu-item *ngIf="!hideDate" (click)="setDateTime(true, null)">Current Date ({{ app.now | async | date: dateFormat }})</button>
</mat-menu>
